export default __webpack_public_path__ + "static/lock-773123e22ba751366547addd7cfcbd94.png";